module.exports = __webpack_public_path__ + "static/media/ADDVA_LOCAL.7b1d49d7.svg";